import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import { weddingInfo } from "../data/data";
const Container = styled.div`
  background: #f2f2f2;
  padding: 5%;
  .card-container {
    display: flex;
    padding: 0 5%;
    justify-content: center;
    @media (max-width: 767px) {
      display: grid;
      grid-template-columns: repeat(1, 2fr);
      grid-gap: 30px;
    }
    @media only screen and (width: 768px) {
      padding: 1%;
    }
  }
  .card {
    width: 299px;
    min-height: 299px;
    justify-self: center;
    margin: 0 12px;
    border-radius: 5px;
    position: relative;
  }
  .intro-wrap {
    text-align: center;
    padding: 10px 0 50px 0;
  }
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
  .card-body {
    position: relative;
    background-color: #fff;
    padding: 25px;
    @media only screen and (width: 768px) {
      padding: 5%;
    }
  }
  .title {
    font-family: "Oswald", sans-serif;
    color: #333333;
    margin: 20px 0;
    font-size: 40px;
    @media (max-width: 767px) {
      font-size: 170%;
    }
  }
  #title {
    font-family: "Oswald", sans-serif;
    color: #333333;
    font-size: 20px;
  }
  #desc {
    font-family: muli;
    color: #123333;
    font-size: 16px;
  }
  .rsvp {
    padding: 10px 30px;
    font-size: 14px;
    display: inline-block;
    /* margin: 0 auto; */
    margin-top: 20px;
    color: #606060;
    background-color: transparent;
    font-family: "Oswald", sans-serif;
    border: solid 1px #fff;
    font-weight: 600;
  }

  .rsvp:hover {
    background-color: #f0394d;
    border-color: #f03;
    color: #fff;
    visibility: visible;
    font-weight: bold;
  }
  .wh95 {
    position: absolute;
    width: 93%;
    height: 50%;
    top: 10px;
    right: 10px;
    left: 10px;
    border: 1px solid #fff;
    display: grid;
    place-items: center;
  }
  .overlay .mask {
    opacity: 0;
    transition: all 0.4s ease-in;
  }

  .overlay .mask:hover {
    opacity: 1;
    text-align: center;
    display: flex;
    align-items: center;
    transition: 0.5s;
    overflow: hidden;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    transition: opacity 0.3s;
    width: 100%;
    height: 100%;
    font-weight: bold;
  }
`;
export default function Wedding() {
  return (
    <>
      <Container>
        <div className="intro-wrap">
          <h3 className="title">THE WEDDING</h3>
          <p id="desc">
            Lorem ipsum dolor sit amet, consectetur adipiscing lorem ipsum dolor
            sit amet, consectetur adipiscing
          </p>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 18, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{ fontSize: 19, marginLeft: -5, color: "white" }}
            />
            <span className="white-line"></span>
          </HeartStyle>
        </div>
        <div className="card-container">
          {weddingInfo &&
            weddingInfo.map((info) => (
              <div className="card" key={info.id}>
                <img src={info.imageUrl} alt="pic" />
                <div className="overlay wh95">
                  <div className="mask">
                    <Link to={`${info.buttonUrl}`}>
                      <span className="rsvp">{info.buttonTitle}</span>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <h3 id="title">{info.title}</h3>
                  <p id="desc">{info.desc}</p>
                </div>
              </div>
            ))}
        </div>
      </Container>
    </>
  );
}
